export enum BannerVariant {
  ThreeButtons = 'A',
  TwoButtonsSimple = 'B',
  Categories = 'C',
  Information = 'D',
  SettingsPage = 'SettingsPage',
}

export const DEFAULT_VARIANT = BannerVariant.ThreeButtons;
